import { SUBSCRIPTION_TYPES } from "utils/helpers/enums/shared.enum";

export class SubscriptionDTO
    {
        features: Feature;
        id: number = 0;
        name: string = ''
        description: string = '' 
        stripeProductId: string;
        stripePriceId: string;
        price: number = 0;
        interval: string = ''
        subscriptionType: SUBSCRIPTION_TYPES;

        constructor(data: Partial<SubscriptionDTO> = {}){
            for(let key in data){
                if(key === 'features'){
                    this[key] = new Feature(data[key]);
                }else{
                    this[key] = data[key];
                }
            }
        }
    }

export class Feature{
    customizable_badge: boolean = false;
    sessions: number = 0;
    post_workshop: boolean = false;
    host_fee_collect: number = 0;
    level: string = ''

    constructor(data: Partial<Feature> = {}){
        for(let key in data){
            if(key === 'host_fee_collect'){
                console.log(this[key], 'before');
                this[key] = parseFloat(data[key].toString().replace('%', ''));
                console.log(this[key], 'after');
            }else{
                this[key] = data[key];
            }
        }
    }
}